import { autoinject } from 'aurelia-framework';
import {DialogController} from "aurelia-dialog";
import { WebApiService } from "../../services/web-api-service";
import { BusyService } from "../../services/busy-service";
import { PageMessageService } from "../../services/page-message-service";
import { Contact } from "../../models/contact";
import 'jquery';
import 'notify';

@autoinject
export class ReportParametersDialog2 {
    constructor(
        protected controller: DialogController,
        private busyService: BusyService,
        private pageMessageService: PageMessageService,
        private api: WebApiService) {
    }

    startDate: string;
    endDate: string;
    reportName: string;
    fileName: string = "Master Approved Carriers";
    format: string="PDF";

    activate(reportName) {
        this.reportName = reportName;
    }

    runReport(report) {
        var reportFragment = encodeURIComponent("Master Approved Carriers&startDate=" + this.startDate + "&endDate=" + this.endDate);
        window.open("/Report/Download?fileName=" + encodeURIComponent(this.fileName) + "&reportFragment=" + reportFragment + "&format=" + this.format);
    }


}